module.exports = __webpack_public_path__ + "img/274288287_246150461053909_4368712564947012350_n.4e10d395.jpg";